export enum TemplateTypeEnum {
    ACT_RECONCILIATION_XLSX = 'ACT_RECONCILIATION_XLSX',
    ACT_ACCEPTANCE_XLSX = 'ACT_ACCEPTANCE_XLSX',
    INVOICE_RECONCILIATION_XLSX = 'INVOICE_RECONCILIATION_XLSX'
}
